import {useState} from 'react';

export type FilterState<Columns extends string> = {column: Columns; direction: 'up' | 'down'};

const useColumnSorting = <Columns extends string>(initial: FilterState<Columns> | undefined) => {
  const [columnSorting, setColumnSorting] = useState<FilterState<Columns> | undefined>(initial);

  const onColumnFilter = (column: FilterState<Columns>['column']) => {
    if (!columnSorting || columnSorting.column !== column) {
      setColumnSorting({column, direction: 'down'});
      return;
    }

    if (columnSorting.direction === 'down') {
      setColumnSorting({column, direction: 'up'});
      return;
    }

    if (columnSorting.direction === 'up') {
      setColumnSorting(undefined);
      return;
    }
  };

  return {columnSorting, onColumnFilter};
};

const filterByColumn = <RowValue extends any, Columns extends string>(
  elements: RowValue[],
  columnSorting: Record<Columns, {sort: (a: RowValue, b: RowValue) => number}>,
  filter: FilterState<Columns>,
) => {
  const sorted = [...elements].sort(columnSorting[filter.column].sort);

  if (filter.direction === 'down') return sorted;

  return sorted.reverse();
};

export {filterByColumn, useColumnSorting};
